const assets = require('../../assets').default;

// define
const SE_DAMAGE_MOB = "@SE_DAMAGE_MOB";
const SE_PUT_PORIN = "@SE_PUT_PORIN";
const SE_DAMAGE_PORIN = "@SE_DAMAGE_PORIN";
const SE_SELECT_PORIN = "@SE_SELECT_PORIN";
const SE_SELECT_SYSTEM = "@SE_SELECT_SYSTEM";
const SE_GAME_OVER = "@SE_GAME_OVER";
const SE_STAGE_CLEAR = "@SE_STAGE_CLEAR";
const SE_DAMAGE_TREASURE = "@SE_DAMAGE_TREASURE";

class sound {
    constructor() {
        this.audioDamageMob = new Audio(assets.SeDamage);
        this.audioPutPorin = new Audio(assets.SePut);
        this.audioDamagePorin = new Audio(assets.SePorin);
        this.audioSelectPorin = new Audio(assets.SeSelect);
        this.audioSelectSystem = new Audio(assets.SeSystem);
        this.audioGameOver = new Audio(assets.SeGameOver);
        this.audioStageClear = new Audio(assets.SeStageClear);
        this.audioDamageTreasure = new Audio(assets.SeTreasure);
    }

    playSound(type, isEnable = false) {
        if (isEnable) {
            switch (type) {
                case SE_DAMAGE_MOB:
                    return this.audioDamageMob.play();
                case SE_PUT_PORIN:
                    return this.audioPutPorin.play();
                case SE_DAMAGE_PORIN:
                    return this.audioDamagePorin.play();
                case SE_SELECT_PORIN:
                    return this.audioSelectPorin.play();
                case SE_SELECT_SYSTEM:
                    return this.audioSelectSystem.play();
                case SE_GAME_OVER:
                    return this.audioGameOver.play();
                case SE_STAGE_CLEAR:
                    return this.audioStageClear.play();
                case SE_DAMAGE_TREASURE:
                    return this.audioDamageTreasure.play();
                default:
                    return;
            }
        }
        return;
    }
}

export default {
    sound: new sound(),
    soundType: {
        SE_DAMAGE_MOB,
        SE_PUT_PORIN,
        SE_DAMAGE_PORIN,
        SE_SELECT_PORIN,
        SE_SELECT_SYSTEM,
        SE_GAME_OVER,
        SE_STAGE_CLEAR,
        SE_DAMAGE_TREASURE
    }
}